export default __webpack_public_path__ + "static/media/banner.09e170a1.png";